import { render, staticRenderFns } from "./SimplePageSelectedFilters.container.vue?vue&type=template&id=8a8af782&"
import script from "./SimplePageSelectedFilters.container.vue?vue&type=script&lang=ts&"
export * from "./SimplePageSelectedFilters.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports